import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationDatahubService } from '../../nav/service/navigation-datahub.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { DatePipe } from '@angular/common';
import { LoadingphaseService } from '../../nav/service/loadingphase.service';
import { UiMessageSnackService } from '../../core/components/message-snack/service/message-snack.service';

@Component({
  selector: 'app-dtb-select-popup',
  templateUrl: './dtb-select-popup.component.html',
  styleUrls: ['./dtb-select-popup.component.scss']
})
export class DtbSelectPopupComponent implements OnInit {

  public inputValue = '';
  public searchCols = ['bezeichnung', 'anmerkung', 'add'];
  public selectCols = ['remove', 'kennung', 'anmerkung'];

  public searchresult = new MatTableDataSource<IDtbDisplay>([]);
  public selected = new MatTableDataSource<IDtbDisplay>([]);
  private allDtb: IDtbDisplay[] = [];

  @ViewChild('searchPaginator') searchPaginator: MatPaginator;
  @ViewChild('selectPaginator') selectPaginator: MatPaginator;
  constructor(
    private dialogRef: MatDialogRef<DtbSelectPopupComponent>,
    private navService: NavigationDatahubService,
    private _datePipe: DatePipe,
    private _messageService: UiMessageSnackService,
    private _loadingphaseService: LoadingphaseService,
  ) {

  }

  ngOnInit() {
    this.navService.findDocumentOfCollection('BereichDTB', {}).then(
      (data) => {
        this.allDtb = data;
        this.inputChanged();
      }
    );
    this.searchresult.paginator = this.selectPaginator;
    this.selected.paginator = this.selectPaginator;
  }

  public set loadingPhase(value: boolean) {
    this._loadingphaseService.setLoadingphase(value, 'dtb_select_popup');
  }

  public inputChanged() {
    let filtered: IDtbDisplay[];

    if (!this.inputValue) {
      filtered = this.allDtb;
    } else {
      filtered = this.allDtb.filter(({ bezeichnung }) => bezeichnung.includes(this.inputValue));
    }

    this.updateSearch(filtered.filter(({ _id }) => !this.selected.data.some((elem) => elem._id === _id)));
  }

  public addDtb(element: IDtbDisplay) {
    const data = [...this.selected.data, element];
    this.updateSelected(data);
    this.updateSearch(this.searchresult.data.filter(({ _id }) => _id !== element._id));
  }

  public removeDtb(element: IDtbDisplay) {
    const data = [...this.searchresult.data, element];
    this.updateSelected(this.selected.data.filter(({ _id }) => _id !== element._id));
    this.updateSearch(data);
  }

  public download() {
    this.loadingPhase = true;
    this.navService.postChecklist(this.selected.data.map(({ _id }) => _id)).then(
      (res) => {
        const date = Date.now();
        const blob = new Blob([(res)], { type: 'application/xlsx' });
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${this._datePipe.transform(date, 'yyyy-MM-dd_hh-mm-ss')}_Prüfliste.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.loadingPhase = false;
      },
      (err) => {
        this._messageService.logMessage('ERROR', { uiMessage: err.message || 'Fehler bei der Generierung!' });
        this.loadingPhase = false;
      }).catch(() => {
        this._messageService.logMessage('ERROR', { uiMessage: 'Fehler bei der Generierung!' });
        this.loadingPhase = false;
      });
  }

  public close() {
    this.dialogRef.close();
  }

  private updateSearch(array: IDtbDisplay[]) {
    this.searchresult = new MatTableDataSource(array);
    this.searchresult.paginator = this.searchPaginator;
  }

  private updateSelected(array: IDtbDisplay[]) {
    this.selected = new MatTableDataSource(array);
    this.selected.paginator = this.selectPaginator;
  }

}

interface IDtbDisplay {
  _id: string;
  bezeichnung: string;
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/menu/dtb-select-popup/dtb-select-popup.component.ts